<template>
  <div class="app-container">
    <BjPage ref="BjPage" :serial="true" :get-action="queryApi" :query-params="queryParams"  :search-btn-span="colSpan" :col-span="colSpan" :before-reset-search="beforeResetSearch" @showSetting="SortableTable.show" @header-dragend="SortableTable.handleHeaderDragend" @header-contextmenu="SortableTable.handleHeaderContextmenu">
      <template v-slot:baseForm>
        <el-col :span="colSpan">
          <el-form-item :label="$t('billingPage.companySeller')" prop="clientCode">
            <BjSelectLov v-model="queryParams.clientCode" :option-list="clientCodeList" :placeholder="$t('billingPage.companySeller')" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('billingPage.Status')" prop="status">
            <BjSelectLov v-model="status" :option-list="BILLING_DEPOSIT_STATUS" :clearable="false" @change="editStatus"/>
          </el-form-item>
        </el-col>
        <!-- Transaction Time -->
        <el-col :span="colSpan">
          <el-form-item :label="$t('billingPage.DEPTime')" prop="transferTime">
            <BjDateRangePicker v-model="queryParamsTransTime" :placeholder="$t('billingPage.DEPTime')" />
          </el-form-item>
        </el-col>
      </template>
      <template v-slot:beforeSearchBtn>
        <el-col :span="24 - colSpan">
          <el-tabs :value="queryParamsTradeStatus" type="card" @tab-click="handleTabClick">
            <el-tab-pane v-for="(item, index) in BILLING_DEPOSIT_STATUS_ALL" :key="index" :label="$t(item.label)" :name="item.value" />
          </el-tabs>
        </el-col>
      </template>
      <template v-slot:tableOperation>
        <el-col>
          <el-button type="primary" class="main-btn" @click="onAdd">{{ $t('billingPage.DEPDeposit') }}</el-button>
        </el-col>
      </template>
      <template v-slot:tableColumn>
        <template v-for="(col, index) in dropCols">
          <el-table-column v-if="col.prop !== 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || false" align="center" class-name="item">
            <template slot-scope="scope">
              <template v-if="false" />
              <template v-else-if="col.prop === 'status'">
                {{ $t(BILLING_DEPOSIT_STATUS.bjGet(scope.row[col.prop])) }}
              </template>
              <template v-else-if="col.prop === 'amount'">
                {{scope.row[col.prop] }} AUD
              </template>
              <span v-else-if="col.prop === 'fromDetail'">
                <!-- {{ $t('BjDialogListConfig.Types') }}:{{ scope.row.fromDetail.type||'No Data'}} - {{ $t('billingPage.DEPraw') }}:{{ scope.row.fromDetail.rawInfo||'No Data'}} -->
                {{ scope.row.fromDetail.rawInfo }}
              </span>
              <span v-else>{{ scope.row[col.prop] | timeFilters(scope.row[col.prop]) }}</span>
            </template>
          </el-table-column>

          <el-table-column v-if="col.prop === 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || 'right'" align="center">
            <template slot-scope="props">
              <el-button type="text" class="edit-btn" @click="onView(props.row)">{{ $t('viewText') }}</el-button>
            </template>
          </el-table-column>
        </template>
      </template>
    </BjPage>
  </div>
</template>

<script>
  import pageMiXin from '@/utils/page-mixin.js';
  import { billApi } from '@/api';
  import { 
    BILLING_DEPOSIT_STATUS, 
    BILLING_DEPOSIT_STATUS_ALL, 
  } from '@/utils/constants';
  export default {
    name: 'BusinessBillingDeposit',
    components: {},
    mixins: [pageMiXin],
    data() {
      return {
        colSpan: 4,
        BILLING_DEPOSIT_STATUS,
        BILLING_DEPOSIT_STATUS_ALL,
        queryParamsTradeStatus: 'ALL',
        queryApi: billApi.getDepositList,
        queryParams: {
          clientCode: null,
          status: null,
          transferStartTime: null,
          transferEndTime: null,
        },
        queryParamsTransTime:[],
        status: null,
        labelList: [
          { label: this.$t('billingPage.DEPID'), prop: 'paymentId', isCheck: true, disabled: false,width:270 },
          { label: this.$t('billingPage.CustomerName'), prop: 'clientName', isCheck: true, disabled: false, },
          { label: this.$t('billingPage.DEPDetail'), prop: 'fromDetail', isCheck: true, disabled: false,width:164 },
          { label: this.$t('billingPage.DEPAmount'), prop: 'amount', isCheck: true, disabled: false },
          { label: this.$t('billingPage.DEPReference'), prop: 'reference', isCheck: true, disabled: false },
          { label: this.$t('billingPage.DEPTime'), prop: 'transferTime', isCheck: true, disabled: false },
          { label: this.$t('billingPage.DEPTrans'), prop: 'Trans', isCheck: true, disabled: false, },
          { label: this.$t('billingPage.Status'), prop: 'status', isCheck: true, disabled: false, },
          { label: this.$t('table.operationText'), prop: 'bjTableAction', isCheck: true, disabled: false, width: 150 },
        ],
      };
    },
    mounted() {
      this.getClientInfoList();
    },
    watch: {
      queryParamsTransTime(v) {
        this.queryParams.transferStartTime = (v || [])[0];
        this.queryParams.transferEndTime = (v || [])[1];
      },
    },
    methods: {
      // tab页点击事件
      handleTabClick(tab, event) {
        // tab.name = 'ALL', tab.label = "已完成订单"
        this.queryParamsTradeStatus = tab.name;
        this.status = null;
        if (tab.name == 'ALL') {
          this.queryParams.status = ['Pending','Received','Declined']
        } else if (tab.name == 'Pending') {
          this.queryParams.status = ['Pending']
        } else if (tab.name == 'Received') {
          this.queryParams.status = ['Received']
        } else if(tab.name == 'Declined') {
          this.queryParams.status = ['Declined']
        } 
        setTimeout(() => { this.reFresh(); }, 500);
      },
      // 传参用
      editStatus(n,m){
        this.queryParams.status = [n]
        this.queryParamsTradeStatus = 'ALL'
      },
      // 获取所有客户信息列表
      getClientInfoList() {
        billApi.getClientInfoList().then(res => {
          res.data.forEach(item => {
            item.label = `${item.label} - ${item.value}`;
          });
          this.clientCodeList = res.data;
        });
      },
      // 跳往审核页
      onView(row) {
        this.$router.push({
          name: 'BusinessBillingDeposiInfo',
          query: { id:row.id,type: 'view' },
        });
      },
      // 新增
      onAdd() {
        this.$router.push({
          name: 'BusinessBillingDeposiInfo',
          query: { type: 'add' },
        });
      },
      beforeResetSearch() {
        this.queryParamsTransTime = []
        this.queryParams={
          clientCode: null,
          status: null,
          transferStartTime: null,
          transferEndTime: null,
        },
        this.status = null;
        this.queryParamsTradeStatus = 'ALL'
        return new Promise(resolve => {
          resolve();
        });
      },
    },
  };
</script>
<style lang="scss" scoped>
.el-icon-s-flag {
  float: right;
  line-height: 34px;
}
</style>
